// alternativeMachine.tsx
// 代替設備モーダル
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setRecStatus } from "../../redux/recStartedSlice";
import { AppDispatch, RootState } from "../../redux/store";
import { setShouldFetch } from "../../redux/shouldFetchSlice";
import { useLastClicked } from "../../hooks/useLastClicked";
import { ProcCodeSelect } from "../ui/ProcCodeSelect";
import { MachCodeSelect } from "../ui/MachCodeSelect";
import "./AlternativeMachine.css";
import apiAxios from "../../utils/apiAxios";
import RippleButton from "../ui/rippleButton";
// AgGrid
import { GridApi } from "ag-grid-enterprise";

import { appendAlert } from "../../redux/alertSlice";

interface AlternativeMachineProps {
  rowData: any[];
  onClose: () => void;
  gridApi: GridApi | null;
  altMachineModalButton: () => void;
}

interface PostMachAssignments {
  po_data_num: string;
  po_desc_num: string;
  mach_seq: number;
  mach_code_before: string;
  proc_code_before: string;
  mach_code_after: string;
  proc_code_after: string;
  update_by: string;
}

const AlternativeMachine: React.FC<AlternativeMachineProps> = ({
  rowData,
  onClose,
  gridApi,
  altMachineModalButton,
}) => {
  // 選択工場
  const plant_code = useSelector(
    (state: RootState) => state.queryParams.selectedPlantCode
  );
  const [selectProcList, setSelectProcList] = useState<any[]>([]);
  const [beforeSelectProcName, setBeforeSelectProcName] = useState("");
  const [beforeSelectProcCode, setBeforeSelectProcCode] = useState("");
  const [beforeSelectMachName, setBeforeSelectMachName] = useState("");
  const [beforeSelectMachCode, setBeforeSelectMachCode] = useState("");
  const [afterSelectProc, setAfterSelectProc] = useState("");
  const [afterSelectMach, setAfterSelectMach] = useState("");

  // 変更後加工コードの変更を検知
  const handleAfterProcCodeChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setAfterSelectProc(e.target.value);
  };
  // 変更後機械コードの変更を検知
  const handleAfterMachCodeChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setAfterSelectMach(e.target.value);
  };
  // ログインユーザーID
  const userId = useSelector(
    (state: RootState) => state.user.userInfo?.user_id ?? ""
  );
  const [errorMessage, setErrorMessage] = useState<string>("");

  useEffect(() => {
    // 加工実績一覧でチェックがはいっているレコードのデータを抽出する
    if (gridApi != null) {
      const selectedNodes = gridApi.getSelectedNodes();
      const dispList = selectedNodes.map((node) => {
        return (
          <ul>
            受注NO {node.data.po_desc_num} 受注寸法W {node.data.po_width}{" "}
            受注寸法H {node.data.po_height}
          </ul>
        );
      });
      setSelectProcList(dispList);

      if (selectedNodes.length > 0) {
        setBeforeSelectProcName(selectedNodes[0].data.proc_name);
        setBeforeSelectProcCode(selectedNodes[0].data.proc_code);
        setBeforeSelectMachName(selectedNodes[0].data.mach_name);
        setBeforeSelectMachCode(selectedNodes[0].data.mach_code);
      }
    }
  }, []);

  const dispatch: AppDispatch = useDispatch();
  const { timeSinceLastClick, setLastClicked } = useLastClicked();
  const PostMachAssignments = async () => {
    if (gridApi != null) {
      const selectedNodes = gridApi.getSelectedNodes();
      let postData: PostMachAssignments[] = [];
      selectedNodes.forEach((elem: any) => {
        postData.push({
          po_data_num: elem.data.po_data_num,
          po_desc_num: elem.data.po_desc_num,
          mach_seq: elem.data.mach_seq,
          mach_code_before: beforeSelectMachCode,
          proc_code_before: beforeSelectProcCode,
          mach_code_after: afterSelectMach,
          proc_code_after: afterSelectProc,
          update_by: userId,
        });
      });

      try {
        const responce = await apiAxios.post(`/mach_assignments`, postData);
        console.log(responce.data)
        if (responce.status === 200) {
          onClose();
          dispatch(setShouldFetch(true));
          setLastClicked(new Date());
          dispatch(setRecStatus("disable"));
          altMachineModalButton();
          dispatch(
            appendAlert({
              severity: "success",
              message: "械作業の変更が完了しました。",
              displayTime: 5000,
            })
          );
        }

      } catch (error: any) {
        const message = error.response.data.error;
        setErrorMessage(message);
      }
    }
  };

  return (
    <div className="alt-machine-container">
      <div className="alt-machine-logo-item">
        <img src="images/swap.svg" className="alt-machine-logo" alt="swap" />
      </div>
      <div className="select-item select-label">
        以下を変更<br></br>
        <ul className="select-list-scroll">{selectProcList}</ul>
      </div>
      <div className="from-label-item alt-machine-label">From:変更前</div>
      <div className="from-input-item alt-machine-input">
        <img src="images/proc.svg" className="alt-machine-icon" alt="proc" />
        <div className="option-area">
          <label htmlFor="accrual-date-proc">加工</label>
          <input
            id="accrual-date-proc"
            className="input-140"
            type="text"
            readOnly
            value={`${beforeSelectProcCode}: ${beforeSelectProcName}`}
          />
        </div>
        <img src="images/machine.svg" className="alt-machine-icon" alt="proc" />
        <div className="option-area">
          <label htmlFor="accrual-date-mach">機械名</label>
          <input
            id="accrual-date-mach"
            className="input-140"
            type="text"
            readOnly
            value={`${beforeSelectMachCode}: ${beforeSelectMachName}`}
          />
        </div>
      </div>
      <div className="to-label-item alt-machine-label">To:変更後</div>
      <div className="to-input-item alt-machine-input">
        <img src="images/proc.svg" className="alt-machine-icon" alt="proc" />
        <div className="option-area">
          <ProcCodeSelect
            label="加工"
            plantCode={plant_code}
            selectProcCode={afterSelectProc}
            handleProcCodeChange={handleAfterProcCodeChange}
          />
        </div>
        <img src="images/machine.svg" className="alt-machine-icon" alt="proc" />
        <div className="option-area">
          <MachCodeSelect
            label="機械名"
            plantCode={plant_code}
            procCode={afterSelectProc}
            selectMachCode={afterSelectMach}
            handleMachCodeChange={handleAfterMachCodeChange}
          />
        </div>
      </div>

      <div className="error-item">
        <p>{errorMessage}</p>
      </div>

      {/* 登録ボタン */}
      {afterSelectProc === "" || afterSelectMach === "" ? (
        <button id="proc_befor" className="regist-button-item-disable" disabled>
          登録
        </button>
      ) : (
        <div className="regist-button-item">
          <RippleButton
            width={"180px"}
            heihgt={"50px"}
            borderRadius={"8px"}
            onClick={PostMachAssignments}
            effectSize={160}
            className="bk-secondary"
          >
            <span className="children">登録</span>
          </RippleButton>
        </div>
      )}
    </div>
  );
};

export default AlternativeMachine;
